import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-functionality',
  templateUrl: './new-functionality.component.html',
  styleUrls: ['./new-functionality.component.scss'],
})
export class NewFunctionalityComponent implements OnInit {

  targetRect!: DOMRect;
  isNotSuperAdmin: boolean = true;

  constructor(
    @Inject(DOCUMENT) private document: Document, public dialogRef: MatDialogRef<NewFunctionalityComponent>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any,) {}

  ngOnInit() {
    const target = this.document.querySelector('#nav-biuwer');
    if (target) {
      this.targetRect = target.getBoundingClientRect();
    }
  }

  goToBiuwer() {
    this.dialogRef.close();
    const user = this.data.user && this.data.user.user ? this.data.user.user : this.data.user
    const url = user.accessType?.toLowerCase() === "company" ? (!this.data.isNotSuperAdmin
      ? "companies/dashboard"
      : "companies/" + user.companyUuid + "/dashboard") : (!this.data.isNotSuperAdmin
        ? "agencies/dashboard"
        : "agencies/" + user.agencyUuid + "/dashboard")
    this.data.isNotSuperAdmin ? this.router.navigate([url]) : this.router.navigate(['/stats']);
  }
  

}